module.exports = __webpack_public_path__ + "img/fg.d73e2751.png";